type PaginationLabelArgs = {
  from: number;
  to: number;
  count: number;
};

export const formatTablePaginationLabel = ({ from, to, count }: PaginationLabelArgs): string => {
  const formattedFrom = from.toLocaleString();
  const formattedTo = to.toLocaleString();

  if (count === -1) {
    return `${formattedFrom}-${formattedTo} of more than ${formattedTo}`;
  }

  return `${formattedFrom}-${formattedTo} of ${count.toLocaleString()}`;
};

